import React, { useState } from 'react'
import { Button } from '../../components/button'
import { Status } from '../../components/cards/statusTag'
import Icon from '../../components/icon'
import Dropdown from '../../components/inputs/dropdown'
import { SearchInput } from '../../components/inputs/searchInput'
import { ActivateTeamMemberModal } from '../../components/modal/app_modals/activateTeamMemberModal'
import { CreateTeammateModal } from '../../components/modal/app_modals/createTeamMemberModal'
import { TableComponent } from '../../components/table'
import { HeaderSubheader } from '../../components/typography/HeaderSubheader'
import { getPageFromSkip, getSkipFromPage } from '../../helpers'
import { useGetTeamMembersQuery } from '../../redux-toolkits/user/user.slice'
import { type TeamMember } from '../../redux-toolkits/user/user.type'
import { QueryProps } from '../../redux-toolkits/shared/shared.type'
const TeamMembers: React.FC = () => {
  const [query, setQuery] = useState<QueryProps>({
    skip: 0,
    limit: 20,
    search: undefined,
  })
  const [editing, setEditing] = useState<TeamMember>()
  const [deleting, setDeleting] = useState<TeamMember>()
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openModal, setOpenModal] = useState(false)

  const { data, isFetching } = useGetTeamMembersQuery({ ...query })

  const closeModal = (): void => {
    setOpenModal(false)
    setEditing(undefined)
  }
  return (
    <div className="flex flex-col gap-10">
      <HeaderSubheader
        title="Team members"
        text="A list of all the users in your account including their name,
              title, email and role."
      />

      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="!w-full md:!max-w-[400px]">
          <SearchInput
            searchFunction={(search) => {
              setQuery({
                ...query,
                search: search === '' ? undefined : search,
                skip: 0,
              })
            }}
            placeholder="Search team members"
          />
        </div>

        <Button
          type="button"
          label="Invite Team Member"
          primary
          size="medium"
          onClick={() => {
            setOpenModal(true)
          }}
        />
      </div>

      <div className="w-full overflow-x-scroll">
        <TableComponent
          loading={isFetching}
          headers={[
            'First name',
            'Last name',
            'Email',
            'Role',
            'Status',
            'Actions',
          ]}
          rows={
            data?.data.admins.map((teamMember) => {
              return {
                id: teamMember._id,
                content: [
                  <span
                    key={`${teamMember._id}}-firstName`}
                    className="capitalize"
                  >
                    {teamMember.firstname}
                  </span>,
                  <span
                    key={`${teamMember._id}}-lastname`}
                    className="capitalize"
                  >
                    {teamMember.lastname}
                  </span>,
                  teamMember.email,
                  teamMember.role.name ?? '',
                  <Status
                    key={`${teamMember._id}-status`}
                    text={teamMember.deleted ? 'Inactive' : 'Active'}
                    type={teamMember.deleted ? 'fail' : 'success'}
                  />,
                  <Dropdown
                    className="text-left"
                    key={`${teamMember._id}-controls`}
                    menuButton={
                      <Icon id="ellipses" height={18} width={18} className="" />
                    }
                    menuItems={[
                      {
                        name: 'Edit',
                        value: '',
                        onClick: () => {
                          setEditing(teamMember)
                          setOpenModal(true)
                        },
                      },
                      {
                        name: teamMember.deleted ? 'Activate' : 'Deactivate',
                        value: '',
                        onClick: () => {
                          setDeleting(teamMember)
                          setOpenDeleteModal(true)
                        },
                      },
                    ]}
                  />,
                ],
              }
            }) ?? []
          }
          isEmpty={[0, undefined].includes(data?.data.admins.length)}
          currentPage={getPageFromSkip(Number(query.skip), Number(query.limit))}
          totalDataCount={data?.data.totalCount ?? 0}
          pageLimit={Number(query.limit)}
          onPageChange={(number) => {
            setQuery({
              ...query,
              skip: getSkipFromPage(number, Number(query.limit)),
            })
          }}
        />
      </div>

      <CreateTeammateModal
        teamMember={editing}
        open={openModal}
        closeModal={() => {
          closeModal()
        }}
        onSuccess={() => {
          closeModal()
        }}
      />

      {deleting ? (
        <ActivateTeamMemberModal
          teamMember={deleting}
          open={openDeleteModal}
          closeModal={() => {
            setOpenDeleteModal(false)
            setDeleting(undefined)
          }}
          onSuccess={() => {
            setOpenDeleteModal(false)
            setDeleting(undefined)
          }}
        />
      ) : undefined}
    </div>
  )
}

export default TeamMembers
